export const sortMethods = { recommended: 'recommended', distance: 'distance', overallScore: 'overallScore' } as const;
type SortMethodKey = keyof typeof sortMethods;
export type SortMethod = (typeof sortMethods)[SortMethodKey];
export const DEFAULT_SORT_METHOD: SortMethod = 'recommended';
export function isSortMethod(value: string): value is SortMethod {
  return Object.values(sortMethods).includes(value as SortMethod);
}
